import React, { useState } from 'react';
import { Collapse as BootstrapCollapse } from 'react-bootstrap';
import { ReactComponent as ChevronUp } from '../../assets/svg/chevron-up.svg';

interface Props {
  title: string;
  description?: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

const Collapse = ({ title, description, defaultOpen = true, children }: Props) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="card border-0">
      <button
        type="button"
        className="btn btn-link text-start text-dark text-decoration-none w-100 p-3 shadow-none"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h5 className="mb-1">{title}</h5>
            {description && <p className="mb-0 text-muted fw-normal">{description}</p>}
          </div>
          <span
            style={{
              display: 'inline-block',
              transition: 'transform 0.2s',
              transform: isOpen ? 'none' : 'rotate(180deg)',
            }}
          >
            <ChevronUp />
          </span>
        </div>
      </button>
      <BootstrapCollapse in={isOpen}>
        <div>
          <div className="px-3 pb-3">
            {children}
          </div>
        </div>
      </BootstrapCollapse>
    </div>
  );
};

export default Collapse;
